export const regexpChecker = (value: string, regexp: RegExp): boolean => (regexp.test(value))
